export enum YNType {
  Y = 'Y',
  N = 'N',
}
